// Offizielles Tipwin-Logo (Partner-/Lizenznehmer-Freigabe durch Auftraggeber bestätigt, 09.09.2026).
// Asset: /public/brand/tipwin-logo.png (weiss/rot, transparent).
// Verlinkt auf die offizielle Tipwin-Website (Auftraggeber-Wunsch).
export default function TipwinLogo({ className = "h-7 w-auto" }) {
  return (
    <a
      href="https://www.tipwin.de/"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Tipwin – zur offiziellen Website (öffnet in neuem Tab)"
      className="inline-flex items-center transition-opacity hover:opacity-80"
      data-testid="tipwin-logo-link"
    >
      <img
        src="/brand/tipwin-logo.png"
        alt="Tipwin"
        width="350"
        height="107"
        className={className}
        data-testid="tipwin-logo"
      />
    </a>
  );
}
